// import React, { useState, useEffect } from 'react';
// import { 
//   Home, 
//   User, 
//   BookOpen, 
//   Calendar, 
//   LogOut, 
//   Menu, 
//   X, 
//   CheckCircle,
//   AlertCircle,
//   Brain,
//   Info,
//   Plus
// } from 'lucide-react';
// import { 
//   logout, 
//   verifyUser, 
//   updateUserProfile, 
//   scheduleInterview,
//   setWhatsAppVerified,
//   updateUserData,
//   REGISTRATION_STATUS,
//   isProfileCompleted
// } from "../redux/slice/registerSlice.js";
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import logo from "../assets/urDoer3.png";
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
// import AcademicTest from '../components/TutorDashboard/tutor_exam/TutorExamAppWrapper.js';
// import VerifyWhatsAppNumModal from '../components/TutorDashboard/Components/VerifyWhatsAppNumModal.jsx';

// const MySwal = withReactContent(Swal);

// // Home Screen Component
// const HomeScreen = ({ userData }) => {
//   const navigate = useNavigate();
  
//   return (
//     <div className="max-w-6xl mx-auto px-6 py-10">
//       <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8">
//         <div className="text-center">
//           <div className="w-20 h-20 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-6">
//             <img src={logo} alt="Logo" className="h-12 w-12" />
//           </div>
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             Welcome to Our Portal!
//           </h1>
//           <p className="text-xl text-gray-600 mb-6">
//             Hello {userData?.fullName || 'User'}, we're glad to have you here.
//           </p>
          
//           <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 mb-8">
//             <h2 className="text-2xl font-semibold text-indigo-700 mb-4">Get Started</h2>
//             <p className="text-gray-700 mb-4">
//               Complete your journey with us by exploring the following options:
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <User className="w-8 h-8 text-indigo-500 mb-2" />
//                 <h3 className="font-semibold text-gray-800">Update Profile</h3>
//                 <p className="text-sm text-gray-600">Complete your profile information</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <BookOpen className="w-8 h-8 text-green-500 mb-2" />
//                 <h3 className="font-semibold text-gray-800">Academic Test</h3>
//                 <p className="text-sm text-gray-600">Take your academic assessment</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <Calendar className="w-8 h-8 text-purple-500 mb-2" />
//                 <h3 className="font-semibold text-gray-800">Schedule Interview</h3>
//                 <p className="text-sm text-gray-600">Book your interview slot</p>
//               </div>
//             </div>
//           </div>
          
//           {/* Progress Tracker */}
//           <div className="bg-gray-50 rounded-lg p-6">
//             <h3 className="text-lg font-semibold text-gray-800 mb-4">Your Progress</h3>
//             <div className="flex items-center justify-center space-x-8">
//               <div className="flex flex-col items-center">
//                 <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mb-2">
//                   <CheckCircle className="w-6 h-6 text-white" />
//                 </div>
//                 <span className="text-sm text-gray-600">Registered</span>
//               </div>
//               <div className="w-16 h-1 bg-gray-200 rounded"></div>
//               <div className="flex flex-col items-center">
//                 <div className={`w-10 h-10 ${userData?.registrationStatus >= REGISTRATION_STATUS.PROFILE_COMPLETED ? 'bg-green-500' : 'bg-gray-300'} rounded-full flex items-center justify-center mb-2`}>
//                   <User className="w-6 h-6 text-white" />
//                 </div>
//                 <span className="text-sm text-gray-600">Profile</span>
//               </div>
//               <div className="w-16 h-1 bg-gray-200 rounded"></div>
//               <div className="flex flex-col items-center">
//                 <div className={`w-10 h-10 ${userData?.testStatus === 'completed' ? 'bg-green-500' : 'bg-gray-300'} rounded-full flex items-center justify-center mb-2`}>
//                   <BookOpen className="w-6 h-6 text-white" />
//                 </div>
//                 <span className="text-sm text-gray-600">Test</span>
//               </div>
//               <div className="w-16 h-1 bg-gray-200 rounded"></div>
//               <div className="flex flex-col items-center">
//                 <div className={`w-10 h-10 ${userData?.interviewRequested || userData?.interviewScheduled ? 'bg-green-500' : 'bg-gray-300'} rounded-full flex items-center justify-center mb-2`}>
//                   <Calendar className="w-6 h-6 text-white" />
//                 </div>
//                 <span className="text-sm text-gray-600">Interview</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Profile Component
// const ProfileComponent = ({ userData, onProfileUpdate }) => {
//   const dispatch = useDispatch();
//   const { whatsappVerified, isLoading } = useSelector(state => state.register);

//   // Enhanced helper function to safely handle WhatsApp number trimming
//   const safeWhatsappNumberTrim = (whatsappNumber) => {
//     if (!whatsappNumber) return '';
//     if (typeof whatsappNumber === 'string') {
//       return whatsappNumber.trim();
//     }
//     if (typeof whatsappNumber === 'object' && whatsappNumber !== null) {
//       const numberValue = whatsappNumber.number || whatsappNumber.whatsappNumber || '';
//       return typeof numberValue === 'string' ? numberValue.trim() : String(numberValue).trim();
//     }
//     return String(whatsappNumber).trim();
//   };

//   // Helper function to safely join arrays for display
//   const safeArrayJoin = (arr) => {
//     if (!arr) return '';
//     if (Array.isArray(arr)) return arr.join(', ');
//     if (typeof arr === 'string') return arr;
//     return '';
//   };

//   // Check if profile is completed using the numeric status
//   const profileCompleted = isProfileCompleted(userData?.registrationStatus);

//   // Initialize form data with safe handling
//   const [formData, setFormData] = useState(() => {
//     const existingData = userData || {};
    
//     return {
//       fullName: existingData?.fullName || '',
//       email: existingData?.email || '',
      
//       // Contact Information - safely handle whatsappNumber
//       mobileNumber: (() => {
//         const mobile = existingData?.mobileNumber;
//         if (typeof mobile === 'string') return mobile;
//         if (typeof mobile === 'object' && mobile?.number) return mobile.number;
//         return existingData?.phone || '';
//       })(),
      
//       whatsappNumber: (() => {
//         const whatsapp = existingData?.whatsappNumber;
//         if (typeof whatsapp === 'string') return whatsapp;
//         if (typeof whatsapp === 'object' && whatsapp?.number) return whatsapp.number;
//         return '';
//       })(),
      
//       isWhatsappVerified: existingData?.whatsappNumber?.verified || 
//                          existingData?.isWhatsappVerified || 
//                          whatsappVerified || 
//                          false,
      
//       // Education & Professional Information
//       highestQualification: existingData?.highestQualification || 
//                            existingData?.highest_degree || '',
//       expertiseDomain: existingData?.expertiseDomain || 
//                       existingData?.department || 
//                       existingData?.role || '',
      
//       // Use existing qualifications data if present
//       qualificationsAndCertifications: existingData?.qualificationsAndCertifications || 
//                                       existingData?.qualifications || 
//                                       [],
      
//       // Use existing arrays if present
//       areasOfExpertise: Array.isArray(existingData?.areasOfExpertise) ? existingData.areasOfExpertise : 
//                        Array.isArray(existingData?.subjects) ? existingData.subjects : [],
      
//       softwareSkills: Array.isArray(existingData?.softwareSkills) ? existingData.softwareSkills : 
//                      Array.isArray(existingData?.software_skills) ? existingData.software_skills : [],
      
//       languagesKnown: Array.isArray(existingData?.languagesKnown) ? existingData.languagesKnown : 
//                      Array.isArray(existingData?.languages) ? existingData.languages : [],
      
//       // Use existing timezone
//       timeZone: existingData?.timeZone || 'Asia/Kolkata'
//     };
//   });

//   const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
//   const [updateSuccess, setUpdateSuccess] = useState(false);
//   const [newQualification, setNewQualification] = useState({
//     institution: '',
//     title: '',
//     specialization: '',
//     yearOfCompletion: ''
//   });

//   // Separate state for input values to avoid React controlled component issues
//   const [inputValues, setInputValues] = useState(() => {
//     const existingData = userData || {};
//     return {
//       areasOfExpertise: safeArrayJoin(existingData?.areasOfExpertise || existingData?.subjects || []),
//       softwareSkills: safeArrayJoin(existingData?.softwareSkills || existingData?.software_skills || []),
//       languagesKnown: safeArrayJoin(existingData?.languagesKnown || existingData?.languages || [])
//     };
//   });

//   // Dropdown options
//   const highestQualificationOptions = [
//     'High School (10th)',
//     'Senior Secondary (12th)',
//     'Diploma',
//     'Bachelor\'s Degree',
//     'Master\'s Degree',
//     'PhD/Doctorate',
//     'Professional Certification',
//     'Other'
//   ];

//   // Update form data when userData changes
//   useEffect(() => {
//     if (userData && Object.keys(userData).length > 0) {
//       setFormData(prevFormData => ({
//         fullName: userData?.fullName || prevFormData.fullName,
//         email: userData?.email || prevFormData.email,
        
//         // Safely handle mobile number
//         mobileNumber: (() => {
//           const mobile = userData?.mobileNumber;
//           if (typeof mobile === 'string') return mobile;
//           if (typeof mobile === 'object' && mobile?.number) return mobile.number;
//           return userData?.phone || prevFormData.mobileNumber || '';
//         })(),
        
//         // Safely handle whatsapp number
//         whatsappNumber: (() => {
//           const whatsapp = userData?.whatsappNumber;
//           if (typeof whatsapp === 'string') return whatsapp;
//           if (typeof whatsapp === 'object' && whatsapp?.number) return whatsapp.number;
//           return prevFormData.whatsappNumber || '';
//         })(),
        
//         isWhatsappVerified: userData?.whatsappNumber?.verified || whatsappVerified || prevFormData.isWhatsappVerified,
//         highestQualification: userData?.highestQualification || prevFormData.highestQualification,
//         expertiseDomain: userData?.expertiseDomain || prevFormData.expertiseDomain,
//         qualificationsAndCertifications: userData?.qualificationsAndCertifications?.length > 0 ? 
//                                         userData.qualificationsAndCertifications : prevFormData.qualificationsAndCertifications,
//         areasOfExpertise: userData?.areasOfExpertise?.length > 0 ? userData.areasOfExpertise : prevFormData.areasOfExpertise,
//         softwareSkills: userData?.softwareSkills?.length > 0 ? userData.softwareSkills : prevFormData.softwareSkills,
//         languagesKnown: userData?.languagesKnown?.length > 0 ? userData.languagesKnown : prevFormData.languagesKnown,
//         timeZone: userData?.timeZone || prevFormData.timeZone
//       }));
      
//       // Update input values for display
//       setInputValues({
//         areasOfExpertise: safeArrayJoin(userData?.areasOfExpertise || userData?.subjects || []),
//         softwareSkills: safeArrayJoin(userData?.softwareSkills || userData?.software_skills || []),
//         languagesKnown: safeArrayJoin(userData?.languagesKnown || userData?.languages || [])
//       });
//     }
//   }, [userData, whatsappVerified]);

//   // Sync WhatsApp verification status from Redux
//   useEffect(() => {
//     const isVerified = userData?.whatsappNumber?.verified || whatsappVerified || false;
//     setFormData(prev => ({
//       ...prev,
//       isWhatsappVerified: isVerified
//     }));
//   }, [userData?.whatsappNumber?.verified, whatsappVerified]);

//   const handleInputChange = (e) => {
//     if (profileCompleted) {
//       toast.info('Profile is completed and cannot be modified');
//       return;
//     }
    
//     const { name, value, type, checked } = e.target;
    
//     let processedValue = type === 'checkbox' ? checked : value;
    
//     // Ensure whatsappNumber and mobileNumber are always strings
//     if (name === 'whatsappNumber' || name === 'mobileNumber') {
//       processedValue = typeof value === 'string' ? value : String(value || '');
//     }
    
//     setFormData(prev => ({
//       ...prev,
//       [name]: processedValue
//     }));
//   };

//   const handleArrayInput = (field, value) => {
//     if (profileCompleted) {
//       toast.info('Profile is completed and cannot be modified');
//       return;
//     }
    
//     // Update the input value immediately for better UX
//     setInputValues(prev => ({
//       ...prev,
//       [field]: value
//     }));
    
//     // Process the value into array
//     const items = value ? value.split(',').map(item => item.trim()).filter(item => item !== '') : [];
    
//     setFormData(prev => ({ 
//       ...prev, 
//       [field]: items 
//     }));
//   };

//   // WhatsApp verification handlers
// const handleWhatsAppVerify = () => {
//   if (profileCompleted) {
//     toast.info('Profile is completed and cannot be modified');
//     return;
//   }
  
//   if (formData.isWhatsappVerified) {
//     toast.info('✅ WhatsApp number is already verified!');
//     return;
//   }

//   const whatsappNum = safeWhatsappNumberTrim(formData.whatsappNumber);
  
//   console.log('WhatsApp verification attempt:');
//   console.log('- Raw formData.whatsappNumber:', formData.whatsappNumber);
//   console.log('- Processed WhatsApp number:', whatsappNum);
//   console.log('- Full formData:', formData);
  
//   if (!whatsappNum || whatsappNum === '') {
//     toast.error('Please enter WhatsApp number first');
//     return;
//   }
//   if (!formData.fullName || formData.fullName.trim() === '') {
//     toast.error('Please enter your full name first');
//     return;
//   }
//   if (!/^\d{10}$/.test(whatsappNum)) {
//     toast.error('Please enter a valid 10-digit WhatsApp number');
//     return;
//   }

//   setShowWhatsAppModal(true);
// };


//   const handleWhatsAppVerified = async (verified) => {
//   console.log('WhatsApp verification status changed to:', verified);
//   console.log('Current formData.whatsappNumber before update:', formData.whatsappNumber);
  
//   setFormData(prev => ({ ...prev, isWhatsappVerified: verified }));
  
//   if (verified) {
//     toast.success('✅ WhatsApp number verified successfully!');
    
//     try {
//       // Get the actual WhatsApp number from form input
//       const actualWhatsAppNumber = safeWhatsappNumberTrim(formData.whatsappNumber);
      
//       console.log('Sending actual WhatsApp number to backend:', actualWhatsAppNumber);
      
//       const verificationUpdate = {
//         whatsappNumber: {
//           countryCode: '+91',
//           number: actualWhatsAppNumber, // Use actual number from form
//           verified: true
//         },
//         isWhatsappVerified: true
//       };
      
//       const result = await dispatch(updateUserProfile(verificationUpdate)).unwrap();
      
//       // Update localStorage with actual number
//       if (result) {
//         const localStorageData = {
//           saveTutor: {
//             tutor_id: result._id,
//             name: result.fullName,
//             email: result.email,
//             phone: result.mobileNumber?.number || '',
//             country_code: result.mobileNumber?.countryCode || '+91',
//             whatsappNumber: actualWhatsAppNumber, // Ensure actual number is saved
//             isWhatsappVerified: true,
//             // ... rest of the data
//           }
//         };
        
//         localStorage.setItem('tutor', JSON.stringify(localStorageData));
//         console.log('Updated localStorage with actual WhatsApp number:', actualWhatsAppNumber);
//       }
      
//       toast.success('✅ Verification status synchronized with database!');
//     } catch (error) {
//       console.error('Failed to save WhatsApp verification to database:', error);
//       toast.error('⚠️ Verification successful but failed to sync with database.');
//     }
//   }
// };


//   // Qualification handlers
//   const addQualification = () => {
//     if (profileCompleted) {
//       toast.info('Profile is completed and cannot be modified');
//       return;
//     }
    
//     if (newQualification.institution && newQualification.title) {
//       setFormData(prev => ({
//         ...prev,
//         qualificationsAndCertifications: [...prev.qualificationsAndCertifications, { ...newQualification }]
//       }));
//       setNewQualification({
//         institution: '',
//         title: '',
//         specialization: '',
//         yearOfCompletion: ''
//       });
//     } else {
//       toast.error('Please fill institution and qualification title');
//     }
//   };

//   const removeQualification = (index) => {
//     if (profileCompleted) {
//       toast.info('Profile is completed and cannot be modified');
//       return;
//     }
    
//     setFormData(prev => ({
//       ...prev,
//       qualificationsAndCertifications: prev.qualificationsAndCertifications.filter((_, i) => i !== index)
//     }));
//   };

//   // Enhanced form completion check
//   const isFormComplete = () => {
//     const whatsappNum = safeWhatsappNumberTrim(formData.whatsappNumber);
//     const mobileNum = typeof formData.mobileNumber === 'string' ? formData.mobileNumber.trim() : String(formData.mobileNumber || '').trim();
    
//     const basicInfoComplete = (
//       formData.fullName.trim() !== '' &&
//       mobileNum !== '' &&
//       /^\d{10}$/.test(mobileNum) &&
//       whatsappNum !== '' &&
//       /^\d{10}$/.test(whatsappNum)
//     );

//     const whatsappVerifiedCheck = formData.isWhatsappVerified;

//     const educationComplete = (
//       formData.highestQualification !== '' &&
//       formData.expertiseDomain !== '' &&
//       formData.timeZone !== ''
//     );

//     const qualificationsComplete = (
//       formData.qualificationsAndCertifications.length > 0 &&
//       formData.qualificationsAndCertifications.every(qual => 
//         qual.institution.trim() !== '' && 
//         qual.title.trim() !== '' && 
//         qual.specialization.trim() !== '' && 
//         qual.yearOfCompletion.trim() !== ''
//       )
//     );

//     const skillsComplete = (
//       formData.areasOfExpertise.length > 0 &&
//       formData.softwareSkills.length > 0 &&
//       formData.languagesKnown.length > 0
//     );

//     return basicInfoComplete && whatsappVerifiedCheck && educationComplete && qualificationsComplete && skillsComplete;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (profileCompleted) {
//       toast.info('Profile is completed and cannot be modified');
//       return;
//     }

//     // Validate WhatsApp verification before allowing profile update
//     if (!formData.isWhatsappVerified) {
//       toast.error('Please verify your WhatsApp number before updating profile');
//       return;
//     }

//     try {
//       // Prepare data according to backend API structure
//       const updateData = {
//         fullName: formData.fullName.trim(),
//         mobileNumber: {
//           countryCode: '+91',  
//           number: typeof formData.mobileNumber === 'string' ? formData.mobileNumber.trim() : String(formData.mobileNumber || '').trim()
//         },
//         whatsappNumber: {
//           countryCode: '+91',
//           number: safeWhatsappNumberTrim(formData.whatsappNumber),
//           verified: formData.isWhatsappVerified
//         },
//         highestQualification: formData.highestQualification,
//         expertiseDomain: formData.expertiseDomain,
//         qualificationsAndCertifications: formData.qualificationsAndCertifications,
//         areasOfExpertise: formData.areasOfExpertise,
//         softwareSkills: formData.softwareSkills,
//         languagesKnown: formData.languagesKnown,
//         timeZone: formData.timeZone,
//         isWhatsappVerified: formData.isWhatsappVerified
//       };

//       console.log('Submitting profile update with data:', updateData);

//       const resultAction = await dispatch(updateUserProfile(updateData));
      
//       if (updateUserProfile.fulfilled.match(resultAction)) {
//         const result = resultAction.payload.result;
//         console.log('Profile update successful - Backend response:', result);
        
//         // Update localStorage with the complete backend response
//         if (result) {
//           const localStorageData = {
//             saveTutor: {
//               tutor_id: result._id,
//               name: result.fullName,
//               email: result.email,
//               phone: result.mobileNumber?.number || '',
//               country_code: result.mobileNumber?.countryCode || '+91',
//               whatsappNumber: result.whatsappNumber?.number || '',
//               isWhatsappVerified: result.whatsappNumber?.verified || false,
//               highest_degree: result.highestQualification,
//               department: result.expertiseDomain,
//               role: result.expertiseDomain,
//               subjects: result.areasOfExpertise || [],
//               software_skills: result.softwareSkills || [],
//               languages: result.languagesKnown || [],
//               qualifications: result.qualificationsAndCertifications || [],
//               registrationStatus: result.registrationStatus,
//               screeningStatus: result.screeningStatus,
//               emailVerified: result.emailVerified,
//               interviewRequested: result.interviewRequested,
//               profile_completed: result.registrationStatus >= REGISTRATION_STATUS.PROFILE_COMPLETED,
//               timeZone: result.timeZone || 'Asia/Kolkata',
//               expertiseDomain: result.expertiseDomain,
//               tutor_exam: result.tutor_exam || [],
//               lastExamId: result.lastExamId,
//               lastSubject: result.lastSubject,
//               isTncSubmitted: result.isTncSubmitted || false,
//               status: 'active',
//               tutStatus: result.tutStatus || 'db',
//               Bank: {
//                 acc_no: '',
//                 bank_name: '',
//                 ifsc_code: '',
//                 beneficiary_name: result.fullName,
//                 upi_id: ''
//               }
//             }
//           };
          
//           localStorage.setItem('tutor', JSON.stringify(localStorageData));
//           console.log('Updated localStorage with backend response:', localStorageData);
//         }
        
//         setUpdateSuccess(true);
//         toast.success('✅ Profile updated successfully!');
        
//         // Call parent callback if provided
//         if (onProfileUpdate) {
//           onProfileUpdate(result);
//         }
        
//         // Auto-hide success message after 5 seconds
//         setTimeout(() => {
//           setUpdateSuccess(false);
//         }, 5000);
//       } else {
//         throw new Error(resultAction.payload?.message || 'Update failed');
//       }
      
//     } catch (error) {
//       console.error('Profile update failed:', error);
//       const errorMessage = error?.message || error?.error || 'Failed to update profile. Please try again.';
//       toast.error(`❌ Update Failed: ${errorMessage}`);
//     }
//   };

//   return (
//     <div className="max-w-6xl mx-auto px-4 py-8">
//       <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8">
//         {/* Header Section */}
//         <div className="text-center mb-10">
//           <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
//             <User className="w-8 h-8 text-gray-600" />
//           </div>
//           <h2 className="text-3xl font-bold text-gray-800 mb-2">
//             My Profile
//           </h2>
//           <p className="text-gray-600">
//             {profileCompleted ? 'Your profile is completed and locked for editing' : 'Complete your professional profile to get started'}
//           </p>
//           <div className="w-24 h-1 bg-gray-300 rounded-full mx-auto mt-4"></div>
          
//           {/* Profile Status Banner */}
//           {profileCompleted && (
//             <div className="mt-6 bg-green-50 border-2 border-green-200 rounded-xl p-6 max-w-md mx-auto">
//               <div className="flex items-center justify-center">
//                 <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
//                   <CheckCircle className="w-8 h-8 text-green-600" />
//                 </div>
//                 <div className="text-left">
//                   <h3 className="text-lg font-bold text-green-800">Profile Completed!</h3>
//                   <p className="text-green-700 text-sm">Your registration has been finalized and is now read-only.</p>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-10">
//           {/* Success Message */}
//           {updateSuccess && (
//             <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-50 border-2 border-green-200 rounded-xl p-8 mb-8 shadow-2xl animate-bounce">
//               <div className="flex items-center justify-center">
//                 <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-6 animate-pulse">
//                   <CheckCircle className="w-10 h-10 text-green-600" />
//                 </div>
//                 <div className="text-center">
//                   <h3 className="text-2xl font-bold text-green-800 mb-2">🎉 Profile Updated Successfully!</h3>
//                   <p className="text-green-700 text-lg">Your information has been saved and is now up to date.</p>
//                   <div className="mt-2 text-sm text-green-600">
//                     ✅ All changes have been synchronized with the database
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Basic Information */}
//           <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
//             <div className="flex items-center mb-6">
//               <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center mr-3">
//                 <User className="w-6 h-6 text-white" />
//               </div>
//               <h3 className="text-xl font-semibold text-gray-800">Basic Information</h3>
//               {profileCompleted && (
//                 <div className="ml-auto">
//                   <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
//                     <CheckCircle className="w-3 h-3 mr-1" />
//                     Completed
//                   </span>
//                 </div>
//               )}
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {/* Full Name */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Full Name
//                 </label>
//                 <input 
//                   type="text" 
//                   name="fullName" 
//                   value={formData.fullName} 
//                   onChange={handleInputChange} 
//                   className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
//                     profileCompleted 
//                       ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                       : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                   }`}
//                   placeholder="Enter your full name"
//                   disabled={profileCompleted}
//                   required 
//                 />
//               </div>
              
//               {/* Email ID (disabled) */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3">Email ID</label>
//                 <input 
//                   type="email" 
//                   name="email" 
//                   value={formData.email} 
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 cursor-not-allowed" 
//                   disabled 
//                 />
//               </div>

//               {/* Mobile Number with country code */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Mobile Number
//                 </label>
//                 <div className="flex">
//                   <div className="w-20 px-3 py-3 border border-gray-300 rounded-l-lg bg-gray-100 flex items-center justify-center text-sm font-medium text-gray-700 border-r-0">
//                     +91
//                   </div>
//                   <input 
//                     type="tel" 
//                     name="mobileNumber" 
//                     value={formData.mobileNumber} 
//                     onChange={handleInputChange} 
//                     className={`flex-1 px-4 py-3 border border-gray-300 rounded-r-lg focus:outline-none transition-all duration-200 ${
//                       profileCompleted 
//                         ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                         : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                     }`}
//                     placeholder="9876543210"
//                     pattern="[0-9]{10}"
//                     disabled={profileCompleted}
//                     required
//                   />
//                 </div>
//               </div>

//               {/* WhatsApp Number with verification */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   WhatsApp Number
//                 </label>
//                 <div className="flex gap-3">
//                   <div className="flex flex-1">
//                     <div className="w-20 px-3 py-3 border border-gray-300 rounded-l-lg bg-gray-100 flex items-center justify-center text-sm font-medium text-gray-700 border-r-0">
//                       +91
//                     </div>
//                     <input 
//                       type="tel" 
//                       name="whatsappNumber" 
//                       value={formData.whatsappNumber} 
//                       onChange={handleInputChange} 
//                       className={`flex-1 px-4 py-3 border border-gray-300 rounded-r-lg focus:outline-none transition-all duration-200 ${
//                         profileCompleted 
//                           ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                           : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                       }`}
//                       placeholder="9876543210"
//                       pattern="[0-9]{10}"
//                       disabled={profileCompleted}
//                       required
//                     />
//                   </div>
//                   <button
//                     type="button"
//                     onClick={handleWhatsAppVerify}
//                     className={`px-6 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
//                       formData.isWhatsappVerified || profileCompleted
//                         ? 'bg-green-100 text-green-800 border border-green-300 cursor-default' 
//                         : 'bg-blue-600 text-white hover:bg-blue-700 border border-blue-600'
//                     }`}
//                     disabled={formData.isWhatsappVerified || profileCompleted}
//                   >
//                     {formData.isWhatsappVerified ? '✓ Verified' : 'Verify OTP'}
//                   </button>
//                 </div>
//               </div>

//               {/* Highest Qualification */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Highest Qualification
//                 </label>
//                 <select 
//                   name="highestQualification" 
//                   value={formData.highestQualification} 
//                   onChange={handleInputChange} 
//                   className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
//                     profileCompleted 
//                       ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                       : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                   }`}
//                   disabled={profileCompleted}
//                   required
//                 >
//                   <option value="">Select Qualification</option>
//                   {highestQualificationOptions.map(qual => (
//                     <option key={qual} value={qual}>{qual}</option>
//                   ))}
//                 </select>
//               </div>

//               {/* Expertise Domain */}
//               <div className="md:col-span-2 group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Expertise Domain
//                 </label>
//                 <select 
//                   name="expertiseDomain" 
//                   value={formData.expertiseDomain} 
//                   onChange={handleInputChange} 
//                   className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
//                     profileCompleted 
//                       ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                       : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                   }`}
//                   disabled={profileCompleted}
//                   required
//                 >
//                   <option value="">Select Expertise Domain</option>
//                   <option value="Academic Tutor">Academic Tutor</option>
//                   <option value="Music Tutor">Music Tutor</option>
//                 </select>
//               </div>

//               {/* Time Zone */}
//               <div className="md:col-span-2 group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Time Zone
//                 </label>
//                 <select 
//                   name="timeZone" 
//                   value={formData.timeZone} 
//                   onChange={handleInputChange} 
//                   className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
//                     profileCompleted 
//                       ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                       : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                   }`}
//                   disabled={profileCompleted}
//                   required
//                 >
//                   <option value="">Select Time Zone</option>
//                   <option value="Asia/Kolkata">Asia/Kolkata (IST) - Default</option>
//                   <option value="America/New_York">America/New_York (EST)</option>
//                   <option value="Europe/London">Europe/London (GMT)</option>
//                   <option value="Asia/Singapore">Asia/Singapore (SGT)</option>
//                   <option value="Australia/Sydney">Australia/Sydney (AEDT)</option>
//                   <option value="America/Los_Angeles">America/Los_Angeles (PST)</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Qualifications & Certifications */}
//           <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
//             <div className="flex items-center mb-6">
//               <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center mr-3">
//                 <BookOpen className="w-6 h-6 text-white" />
//               </div>
//               <div>
//                 <h3 className="text-xl font-semibold text-gray-800">Qualifications & Certifications</h3>
//                 <p className="text-sm text-gray-600 mt-1">At least one qualification/certification is required</p>
//               </div>
//               {profileCompleted && (
//                 <div className="ml-auto">
//                   <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
//                     <CheckCircle className="w-3 h-3 mr-1" />
//                     Completed
//                   </span>
//                 </div>
//               )}
//             </div>
            
//             {/* Existing Qualifications */}
//             {formData.qualificationsAndCertifications.map((qual, index) => (
//               <div key={index} className="bg-white p-6 rounded-lg mb-4 border border-gray-200 hover:border-gray-300 transition-all duration-200">
//                 <div className="flex justify-between items-start mb-3">
//                   <div className="flex items-start">
//                     <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center mr-3 mt-1">
//                       <span className="text-white font-medium text-sm">{index + 1}</span>
//                     </div>
//                     <div>
//                       <h4 className="font-semibold text-gray-800 text-lg">{qual.title}</h4>
//                       <p className="text-blue-600 font-medium">{qual.institution}</p>
//                     </div>
//                   </div>
//                   <button 
//                     type="button" 
//                     onClick={() => removeQualification(index)}
//                     className={`${
//                       profileCompleted 
//                         ? 'text-gray-300 cursor-not-allowed' 
//                         : 'text-gray-400 hover:text-red-600 hover:bg-red-50'
//                     } p-2 rounded-lg transition-all duration-200`}
//                     disabled={profileCompleted}
//                   >
//                     <X className="w-5 h-5" />
//                   </button>
//                 </div>
//                 <div className="ml-11 space-y-1">
//                   <p className="text-sm text-gray-600"><span className="font-medium">Specialization:</span> {qual.specialization}</p>
//                   <p className="text-sm text-gray-600"><span className="font-medium">Year:</span> {qual.yearOfCompletion}</p>
//                 </div>
//               </div>
//             ))}

//             {/* Add New Qualification */}
//             {!profileCompleted && (
//               <div className="bg-white p-6 rounded-lg border-2 border-dashed border-gray-300 hover:border-gray-400 transition-all duration-200">
//                 <h4 className="font-medium text-gray-700 mb-4 flex items-center">
//                   <Plus className="w-5 h-5 mr-2 text-gray-500" />
//                   Add Qualification/Certification
//                 </h4>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <input 
//                     type="text" 
//                     placeholder="Institution/Organization*" 
//                     value={newQualification.institution}
//                     onChange={(e) => setNewQualification(prev => ({...prev, institution: e.target.value}))}
//                     className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
//                   />
//                   <input 
//                     type="text" 
//                     placeholder="Qualification/Certification Title*" 
//                     value={newQualification.title}
//                     onChange={(e) => setNewQualification(prev => ({...prev, title: e.target.value}))}
//                     className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
//                   />
//                   <input 
//                     type="text" 
//                     placeholder="Specialization/Field of Study*" 
//                     value={newQualification.specialization}
//                     onChange={(e) => setNewQualification(prev => ({...prev, specialization: e.target.value}))}
//                     className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
//                   />
//                   <input 
//                     type="text" 
//                     placeholder="Year of Completion*" 
//                     value={newQualification.yearOfCompletion}
//                     onChange={(e) => setNewQualification(prev => ({...prev, yearOfCompletion: e.target.value}))}
//                     className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
//                   />
//                 </div>
//                 <button 
//                   type="button" 
//                   onClick={addQualification}
//                   className="mt-4 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium"
//                 >
//                   Add Qualification
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Areas of Expertise & Skills */}
//           <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
//             <div className="flex items-center mb-6">
//               <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center mr-3">
//                 <Brain className="w-6 h-6 text-white" />
//               </div>
//               <h3 className="text-xl font-semibold text-gray-800">Expertise & Skills</h3>
//               {profileCompleted && (
//                 <div className="ml-auto">
//                   <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
//                     <CheckCircle className="w-3 h-3 mr-1" />
//                     Completed
//                   </span>
//                 </div>
//               )}
//             </div>
//             <div className="grid grid-cols-1 gap-8">
//               {/* Areas of Expertise */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Areas of Expertise/Interested Subjects
//                 </label>
//                 <div className="relative">
//                   <textarea 
//                     name="areasOfExpertise"
//                     value={inputValues.areasOfExpertise} 
//                     onChange={(e) => handleArrayInput('areasOfExpertise', e.target.value)}
//                     className={`w-full px-4 py-4 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 resize-none ${
//                       profileCompleted 
//                         ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                         : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                     }`}
//                     rows="3"
//                     placeholder="Type your areas of expertise separated by commas (e.g., Mathematics, Physics, Chemistry, Programming)"
//                     disabled={profileCompleted}
//                     required
//                   />
//                   <div className="absolute top-2 right-2">
//                     <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full font-medium">
//                       {formData.areasOfExpertise?.length || 0} areas
//                     </span>
//                   </div>
//                 </div>
//                 <div className="mt-2 flex flex-wrap gap-2">
//                   {formData.areasOfExpertise && formData.areasOfExpertise.map((area, index) => (
//                     <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
//                       {area}
//                     </span>
//                   ))}
//                 </div>
//                 <p className="text-xs text-gray-500 mt-2 flex items-center">
//                   <Info className="w-3 h-3 mr-1" />
//                   Separate multiple areas with commas. Each area will be added as a separate tag.
//                 </p>
//               </div>
              
//               {/* Software Skills */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Software Skills
//                 </label>
//                 <div className="relative">
//                   <textarea 
//                     name="softwareSkills"
//                     value={inputValues.softwareSkills} 
//                     onChange={(e) => handleArrayInput('softwareSkills', e.target.value)}
//                     className={`w-full px-4 py-4 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 resize-none ${
//                       profileCompleted 
//                         ? 'bg-gray-100 text-gray-600 cursor-not-allowed'
//                         : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                     }`}
//                     rows="3"
//                     placeholder="Type your software skills separated by commas (e.g., Python, React, MATLAB, AutoCAD)"
//                     disabled={profileCompleted}
//                     required
//                   />
//                   <div className="absolute top-2 right-2">
//                     <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full font-medium">
//                       {formData.softwareSkills?.length || 0} skills
//                     </span>
//                   </div>
//                 </div>
//                 <div className="mt-2 flex flex-wrap gap-2">
//                   {formData.softwareSkills && formData.softwareSkills.map((skill, index) => (
//                     <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
//                       {skill}
//                     </span>
//                   ))}
//                 </div>
//                 <p className="text-xs text-gray-500 mt-2 flex items-center">
//                   <Info className="w-3 h-3 mr-1" />
//                   List programming languages, software tools, and technical skills you're proficient in.
//                 </p>
//               </div>
              
//               {/* Languages Known */}
//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
//                   <span className="text-red-500 mr-1">*</span>
//                   Languages Known
//                 </label>
//                 <div className="relative">
//                   <textarea 
//                     name="languagesKnown"
//                     value={inputValues.languagesKnown} 
//                     onChange={(e) => handleArrayInput('languagesKnown', e.target.value)}
//                     className={`w-full px-4 py-4 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 resize-none ${
//                       profileCompleted 
//                         ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
//                         : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
//                     }`}
//                     rows="2"
//                     placeholder="Type languages you know separated by commas (e.g., English, Hindi, Tamil, French)"
//                     disabled={profileCompleted}
//                     required
//                   />
//                   <div className="absolute top-2 right-2">
//                     <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full font-medium">
//                       {formData.languagesKnown?.length || 0} languages
//                     </span>
//                   </div>
//                 </div>
//                 <div className="mt-2 flex flex-wrap gap-2">
//                   {formData.languagesKnown && formData.languagesKnown.map((language, index) => (
//                     <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800 border border-purple-200">
//                       {language}
//                     </span>
//                   ))}
//                 </div>
//                 <p className="text-xs text-gray-500 mt-2 flex items-center">
//                   <Info className="w-3 h-3 mr-1" />
//                   Include all languages you can communicate effectively in.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Submit Button */}
//           {!profileCompleted && (
//             <div className="flex justify-center pt-8">
//               <button
//                 type="submit"
//                 disabled={isLoading || !isFormComplete() || !formData.isWhatsappVerified}
//                 className={`px-12 py-4 rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-300 disabled:cursor-not-allowed transition-all duration-300 font-semibold text-lg ${
//                   isFormComplete() && formData.isWhatsappVerified && !isLoading
//                     ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-xl'
//                     : 'bg-gray-300 text-gray-500 cursor-not-allowed shadow-md'
//                 }`}
//               >
//                 {isLoading ? (
//                   <div className="flex items-center">
//                     <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//                     Updating Profile...
//                   </div>
//                 ) : !formData.isWhatsappVerified ? (
//                   <div className="flex items-center">
//                     <AlertCircle className="w-5 h-5 mr-2" />
//                     Verify WhatsApp First
//                   </div>
//                 ) : isFormComplete() ? (
//                   <div className="flex items-center">
//                     <CheckCircle className="w-5 h-5 mr-2" />
//                     Update Profile
//                   </div>
//                 ) : (
//                   <div className="flex items-center">
//                     <AlertCircle className="w-5 h-5 mr-2" />
//                     Complete All Required Fields
//                   </div>
//                 )}
//               </button>
//             </div>
//           )}
          
//           {/* Profile Completed Message */}
//           {profileCompleted && (
//             <div className="flex justify-center pt-8">
//               <div className="bg-green-50 border-2 border-green-200 rounded-xl p-8 max-w-md text-center">
//                 <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                   <CheckCircle className="w-10 h-10 text-green-600" />
//                 </div>
//                 <h3 className="text-xl font-bold text-green-800 mb-2">Profile Completed!</h3>
//                 <p className="text-green-700 mb-4">
//                   Your registration process has been finalized. Your profile is now locked for editing to maintain data integrity.
//                 </p>
//                 <div className="text-sm text-green-600 bg-green-100 rounded-lg px-4 py-2">
//                   <strong>Status:</strong> Registration Complete
//                 </div>
//               </div>
//             </div>
//           )}
          
//           {/* Form completion indicator */}
//           {!isFormComplete() && !profileCompleted && (
//             <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mt-8">
//               <div className="flex items-center mb-4">
//                 <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
//                   <AlertCircle className="w-5 h-5 text-white" />
//                 </div>
//                 <span className="text-yellow-800 font-semibold text-lg">Complete Your Profile</span>
//               </div>
//               <p className="text-yellow-700 mb-4">Please fill in all required fields marked with * to submit your profile.</p>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                 {!formData.fullName.trim() && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Full Name
//                   </div>
//                 )}
//                 {(() => {
//                   const mobileNum = typeof formData.mobileNumber === 'string' ? formData.mobileNumber.trim() : String(formData.mobileNumber || '').trim();
//                   return (!mobileNum || !/^\d{10}$/.test(mobileNum)) && (
//                     <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                       <X className="w-4 h-4 mr-2 text-red-500" />
//                       Valid Mobile Number (10 digits)
//                     </div>
//                   );
//                 })()}
//                 {(() => {
//                   const whatsappNum = safeWhatsappNumberTrim(formData.whatsappNumber);
//                   return (!whatsappNum || !/^\d{10}$/.test(whatsappNum)) && (
//                     <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                       <X className="w-4 h-4 mr-2 text-red-500" />
//                       Valid WhatsApp Number (10 digits)
//                     </div>
//                   );
//                 })()}
//                 {!formData.isWhatsappVerified && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     WhatsApp Number Verification Required
//                   </div>
//                 )}
//                 {!formData.highestQualification && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Highest Qualification
//                   </div>
//                 )}
//                 {!formData.expertiseDomain && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Expertise Domain
//                   </div>
//                 )}
//                 {formData.qualificationsAndCertifications.length === 0 && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     At least one Qualification/Certification
//                   </div>
//                 )}
//                 {formData.areasOfExpertise.length === 0 && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Areas of Expertise
//                   </div>
//                 )}
//                 {formData.softwareSkills.length === 0 && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Software Skills
//                   </div>
//                 )}
//                 {formData.languagesKnown.length === 0 && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Languages Known
//                   </div>
//                 )}
//                 {!formData.timeZone && (
//                   <div className="flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-lg px-3 py-2">
//                     <X className="w-4 h-4 mr-2 text-red-500" />
//                     Time Zone
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </form>

//         {/* WhatsApp Verification Modal */}
//         <VerifyWhatsAppNumModal
//           open={showWhatsAppModal}
//           handleClose={() => setShowWhatsAppModal(false)}
//           setIsWhatsappVerified={handleWhatsAppVerified}
//           waNum={safeWhatsappNumberTrim(formData.whatsappNumber)}
//           name={formData.fullName?.trim() || ''}
//           isVerified={formData.isWhatsappVerified}
//         />
//       </div>
//     </div>
//   );
// };

// // Academic Test Component
// const AcademicTestComponent = ({ userData }) => {
//   const [showTest, setShowTest] = useState(false);
//   const [isLocalStorageReady, setIsLocalStorageReady] = useState(false);

//   const handleStartTest = () => {
//     setShowTest(true);
//   };

//   const handleBackToOverview = () => {
//     setShowTest(false);
//   };

//   // Check if user is eligible for academic test (based on role)
//   const isAcademicRole = userData?.expertiseDomain === 'Academic Tutor';

//   // Setup localStorage data that tutorExamApp expects - only when needed
//   useEffect(() => {
//     const checkAndSetupLocalStorage = () => {
//       try {
//         const existingTutorData = localStorage.getItem('tutor');
        
//         if (existingTutorData) {
//           const parsed = JSON.parse(existingTutorData);
          
//           // Validate existing data structure
//           if (parsed?.saveTutor?.tutor_id && parsed?.saveTutor?.name) {
//             console.log('Using existing localStorage tutor data from ProfileComponent:', parsed);
//             setIsLocalStorageReady(true);
//             return; // Use existing data, don't override
//           }
//         }
        
//         // Only set fallback data if no valid data exists
//         console.log('No valid localStorage found, setting up fallback data matching schema');
        
//         const tutorData = {
//           saveTutor: {
//             tutor_id: userData?._id || `USER_${Date.now()}`,
//             name: userData?.fullName || 'Test User',
//             email: userData?.email || '',
//             role: userData?.expertiseDomain || 'Academic Tutor',
            
//             Bank: {
//               acc_no: '',
//               bank_name: '',
//               ifsc_code: '',
//               beneficiary_name: userData?.fullName || 'Test User',
//               upi_id: ''
//             },
            
//             // Contact info matching schema
//             phone: userData?.mobileNumber?.number || userData?.mobileNumber || '',
//             country_code: userData?.mobileNumber?.countryCode || '+91',
//             whatsappNumber: userData?.whatsappNumber?.number || userData?.whatsappNumber || '',
//             isWhatsappVerified: userData?.whatsappNumber?.verified || false,
            
//             // Education matching schema
//             highest_degree: userData?.highestQualification || '',
//             department: userData?.expertiseDomain || '',
            
//             // Arrays matching schema
//             subjects: userData?.areasOfExpertise || [],
//             software_skills: userData?.softwareSkills || [],
//             languages: userData?.languagesKnown || [],
//             qualifications: userData?.qualificationsAndCertifications || [],
            
//             // Status fields from schema
//             profile_completed: userData?.registrationStatus >= REGISTRATION_STATUS.PROFILE_COMPLETED || true,
//             status: 'active',
//             tutStatus: userData?.tutStatus || 'db',
//             registrationStatus: userData?.registrationStatus,
//             screeningStatus: userData?.screeningStatus,
//             emailVerified: userData?.emailVerified,
//             interviewRequested: userData?.interviewRequested,
            
//             // Schema fields
//             timeZone: userData?.timeZone || 'Asia/Kolkata',
//             expertiseDomain: userData?.expertiseDomain || 'Academic Tutor',
            
//             // Exam related fields
//             tutor_exam: userData?.tutor_exam || [],
//             lastExamId: userData?.lastExamId,
//             lastSubject: userData?.lastSubject,
//             isTncSubmitted: userData?.isTncSubmitted || false
//           }
//         };
        
//         localStorage.setItem('tutor', JSON.stringify(tutorData));
//         console.log('Fallback localStorage tutor data set matching schema:', tutorData);
        
//         setTimeout(() => {
//           setIsLocalStorageReady(true);
//         }, 100);
        
//       } catch (error) {
//         console.error('Error setting up localStorage for exam:', error);
//         setIsLocalStorageReady(false);
//       }
//     };
    
//     checkAndSetupLocalStorage();
//   }, [userData, showTest]);

//   // If test is started, show the actual test component
//   if (showTest && isAcademicRole && userData?.testStatus !== 'completed') {
//     return (
//       <div className="max-w-full mx-auto">
//         <div className="mb-4">
//           <button
//             onClick={handleBackToOverview}
//             className="flex items-center text-indigo-600 hover:text-indigo-700 mb-4"
//           >
//             ← Back to Overview
//           </button>
//         </div>
//         {/* Only render AcademicTest if localStorage data is properly set */}
//         {isLocalStorageReady ? (
//           (() => {
//             // Double check localStorage is valid before rendering
//             try {
//               const tutorData = localStorage.getItem('tutor');
//               if (tutorData) {
//                 const parsed = JSON.parse(tutorData);
//                 if (parsed?.saveTutor?.tutor_id) {
//                   return <AcademicTest />;
//                 }
//               }
//               // If localStorage is not valid, show loading
//               return (
//                 <div className="flex items-center justify-center p-8">
//                   <div className="text-center">
//                     <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
//                     <p className="text-gray-600">Setting up test environment...</p>
//                   </div>
//                 </div>
//               );
//             } catch (error) {
//               console.error('Error validating localStorage:', error);
//               return (
//                 <div className="flex items-center justify-center p-8">
//                   <div className="text-center">
//                     <div className="text-red-600 mb-4">⚠️</div>
//                     <p className="text-gray-600">Error setting up test environment. Please try again.</p>
//                     <button 
//                       onClick={() => window.location.reload()} 
//                       className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
//                     >
//                       Retry
//                     </button>
//                   </div>
//                 </div>
//               );
//             }
//           })()
//         ) : (
//           <div className="flex items-center justify-center p-8">
//             <div className="text-center">
//               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
//               <p className="text-gray-600">Preparing test environment...</p>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-4xl mx-auto px-6 py-10">
//       <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-10">Academic Test</h2>
        
//         {isAcademicRole ? (
//           <div className="text-center">
//             <div className="mb-8">
//               <BookOpen className="w-16 h-16 text-indigo-500 mx-auto mb-4" />
//               <h3 className="text-2xl font-bold text-gray-800 mb-4">Take Your Academic Assessment</h3>
//               <p className="text-gray-600 mb-6">
//                 Complete the academic test to demonstrate your expertise in your field.
//               </p>
//             </div>
            
//             {userData?.testStatus === 'completed' ? (
//               <div className="bg-green-50 border border-green-200 rounded-lg p-6">
//                 <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
//                 <h4 className="text-lg font-semibold text-green-800 mb-2">Test Completed!</h4>
//                 <p className="text-green-700">
//                   You have successfully completed the academic test. Results are being reviewed.
//                 </p>
//               </div>
//             ) : (
//               <button
//                 onClick={handleStartTest}
//                 className="bg-indigo-600 text-white px-8 py-3 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               >
//                 Start Academic Test
//               </button>
//             )}
//           </div>
//         ) : (
//           <div className="text-center">
//             <AlertCircle className="w-16 h-16 text-orange-500 mx-auto mb-4" />
//             <h3 className="text-2xl font-bold text-gray-800 mb-4">Not Applicable</h3>
//             <p className="text-gray-600">
//               Academic test is only required for Academic Tutors. Music Tutors need to schedule an interview instead.
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // Interview Scheduler Component
// const InterviewScheduler = ({ userData }) => {
//   const dispatch = useDispatch();
//   const { isLoading } = useSelector(state => state.register);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [selectedTime, setSelectedTime] = useState('');
//   const [additionalNotes, setAdditionalNotes] = useState('');

//   const timeSlots = [
//     '09:00 AM - 10:00 AM',
//     '10:00 AM - 11:00 AM', 
//     '11:00 AM - 12:00 PM',
//     '02:00 PM - 03:00 PM',
//     '03:00 PM - 04:00 PM',
//     '04:00 PM - 05:00 PM',
//     '05:00 PM - 06:00 PM',
//     '06:00 PM - 07:00 PM'
//   ];

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedDate || !selectedTime) {
//       toast.error('Please select date and time');
//       return;
//     }

//     try {
//       const interviewData = {
//         preferredDate: selectedDate,
//         preferredTime: selectedTime,
//         additionalNotes: additionalNotes
//       };

//       await dispatch(scheduleInterview(interviewData)).unwrap();
//       toast.success('Interview scheduled successfully!');
      
//       // Reset form
//       setSelectedDate('');
//       setSelectedTime('');
//       setAdditionalNotes('');
//     } catch (error) {
//       toast.error(error?.message || 'Failed to schedule interview');
//     }
//   };

//   return (
//     <div className="max-w-4xl mx-auto px-6 py-10">
//       <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-10">Schedule Interview</h2>

//         {userData?.interviewRequested || userData?.interviewScheduled ? (
//           <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
//             <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
//             <h3 className="text-lg font-semibold text-green-800 mb-2">Interview Already Scheduled</h3>
//             <p className="text-green-700">
//               Your interview has been scheduled. Check your email for details.
//             </p>
//           </div>
//         ) : (
//           <form onSubmit={handleSubmit} className="space-y-6">
//             {/* Date Selection */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 <span className="text-red-500 mr-1">*</span>
//                 Preferred Date
//               </label>
//               <input
//                 type="date"
//                 value={selectedDate}
//                 onChange={(e) => setSelectedDate(e.target.value)}
//                 min={new Date().toISOString().split('T')[0]}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                 required
//               />
//             </div>

//             {/* Time Selection */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 <span className="text-red-500 mr-1">*</span>
//                 Preferred Time
//               </label>
//               <select
//                 value={selectedTime}
//                 onChange={(e) => setSelectedTime(e.target.value)}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                 required
//               >
//                 <option value="">Select Time Slot</option>
//                 {timeSlots.map((time) => (
//                   <option key={time} value={time}>
//                     {time}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Notes */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Additional Notes (Optional)
//               </label>
//               <textarea
//                 value={additionalNotes}
//                 onChange={(e) => setAdditionalNotes(e.target.value)}
//                 rows="4"
//                 placeholder="Any specific requirements or notes for the interview..."
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               />
//             </div>

//             {/* Submit Button */}
//             <div className="pt-4">
//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="w-full bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
//               >
//                 {isLoading ? 'Scheduling Interview...' : 'Schedule Interview'}
//               </button>
//             </div>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// // Main Register Dashboard Component
// const RegisterDashboard = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { userData, isLoading, whatsappVerified } = useSelector((state) => state.register);
//   const [activeSection, setActiveSection] = useState('home');
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   useEffect(() => {
//     // Verify user on component mount
//     if (!userData) {
//       dispatch(verifyUser());
//     }
//   }, [dispatch, userData]);

//   const handleLogout = () => {
//     localStorage.removeItem('registerToken');
//     localStorage.removeItem('tutor'); // Also cleanup tutor data
//     sessionStorage.clear();
//     dispatch(logout());
//     MySwal.fire({
//       icon: 'success',
//       title: 'Logged Out!',
//       text: 'You have been logged out successfully.',
//       confirmButtonColor: '#3085d6',
//       confirmButtonText: 'OK'
//     }).then(() => {
//       navigate('/register', { replace: true });
//     });
//   };

//   const handleProfileUpdate = (updatedData) => {
//     console.log('Profile updated:', updatedData);
//     // Update userData in Redux state
//     dispatch(updateUserData(updatedData));
//   };

//   const sidebarItems = [
//     { id: 'home', label: 'Home', icon: Home },
//     { id: 'profile', label: 'My Profile', icon: User },
//     { id: 'academic-test', label: 'Academic Test', icon: BookOpen },
//     { id: 'interview', label: 'Schedule Interview', icon: Calendar },
//     { id: 'logout', label: 'Logout', icon: LogOut }
//   ];

//   if (isLoading && !userData) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 flex">
//       {/* Sidebar */}
//       <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
//         sidebarOpen ? 'translate-x-0' : '-translate-x-full'
//       } lg:translate-x-0 lg:static lg:inset-0`}>
//         <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
//           <div className="flex items-center">
//             <div className="w-10 h-14 bg-indigo-500 rounded-lg flex items-center justify-center">
//               <img src={logo} alt="Logo" className="h-7 w-7" />
//             </div>
//             <span className="ml-2 text-xl font-semibold text-gray-800">Register</span>
//           </div>
//           <button
//             onClick={() => setSidebarOpen(false)}
//             className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500"
//           >
//             <X className="w-5 h-5" />
//           </button>
//         </div>
        
//         <nav className="mt-8">
//           {sidebarItems.map((item) => {
//             const Icon = item.icon;
//             return (
//               <button
//                 key={item.id}
//                 onClick={() => {
//                   if (item.id === 'logout') {
//                     handleLogout();
//                   } else {
//                     setActiveSection(item.id);
//                     setSidebarOpen(false);
//                   }
//                 }}
//                 className={`w-full flex items-center px-4 py-3 text-left hover:bg-gray-50 transition-colors ${
//                   activeSection === item.id ? 'bg-indigo-50 text-indigo-600 border-r-2 border-indigo-600' : 'text-gray-700'
//                 }`}
//               >
//                 <Icon className="w-5 h-5 mr-3" />
//                 {item.label}
//               </button>
//             );
//           })}
//         </nav>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 lg:ml-0">
//         {/* Header */}
//         <div className="bg-white shadow-sm border-b border-gray-200">
//           <div className="flex items-center justify-between h-16 px-4">
//             <div className="flex items-center">
//               <button
//                 onClick={() => setSidebarOpen(true)}
//                 className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500"
//                            >
//                 <Menu className="w-5 h-5" />
//               </button>
//               <div className="lg:hidden flex items-center ml-2">
//                 <div className="w-8 h-8 bg-indigo-500 rounded-lg flex items-center justify-center">
//                   <img src={logo} alt="Logo" className="h-5 w-5" />
//                 </div>
//                 <span className="ml-2 text-xl font-semibold text-gray-800">Register</span>
//               </div>
//             </div>
            
//             <div className="flex items-center space-x-4">
//               <span className="text-sm text-gray-600">{userData?.email}</span>
//               <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
//                 <User className="w-4 h-4 text-gray-400" />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Page Content */}
//         <div className="p-6">
//           {activeSection === 'home' && <HomeScreen userData={userData} />}
//           {activeSection === 'profile' && <ProfileComponent userData={userData} onProfileUpdate={handleProfileUpdate} />}
//           {activeSection === 'academic-test' && <AcademicTestComponent userData={userData} />}
//           {activeSection === 'interview' && <InterviewScheduler userData={userData} />}
//         </div>
//       </div>

//       {/* Sidebar Overlay */}
//       {sidebarOpen && (
//         <div 
//           className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default RegisterDashboard;

import React, { useState, useEffect } from 'react';
import { 
  Home, 
  User, 
  BookOpen, 
  Calendar, 
  LogOut, 
  Menu, 
  X, 
  CheckCircle,
  AlertCircle,
  Brain,
  Info,
  Plus
} from 'lucide-react';
import { 
  logout, 
  verifyUser, 
  updateUserProfile, 
  scheduleInterview,
  setWhatsAppVerified,
  updateUserData,
  REGISTRATION_STATUS,
  isProfileCompleted
} from "../redux/slice/registerSlice.js";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from "../assets/urDoer3.png";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import AcademicTest from '../components/TutorDashboard/tutor_exam/TutorExamAppWrapper.js';
import VerifyWhatsAppNumModal from '../components/TutorDashboard/Components/VerifyWhatsAppNumModal.jsx';

const MySwal = withReactContent(Swal);

// Home Screen Component
const HomeScreen = ({ userData }) => {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8">
        <div className="text-center">
          <div className="w-20 h-20 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <img src={logo} alt="Logo" className="h-12 w-12" />
          </div>
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Welcome to Our Portal!
          </h1>
          <p className="text-xl text-gray-600 mb-6">
            Hello {userData?.fullName || 'User'}, we're glad to have you here.
          </p>
          
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 mb-8">
            <h2 className="text-2xl font-semibold text-indigo-700 mb-4">Get Started</h2>
            <p className="text-gray-700 mb-4">
              Complete your journey with us by exploring the following options:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <User className="w-8 h-8 text-indigo-500 mb-2" />
                <h3 className="font-semibold text-gray-800">Update Profile</h3>
                <p className="text-sm text-gray-600">Complete your profile information</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <BookOpen className="w-8 h-8 text-green-500 mb-2" />
                <h3 className="font-semibold text-gray-800">Academic Test</h3>
                <p className="text-sm text-gray-600">Take your academic assessment</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <Calendar className="w-8 h-8 text-purple-500 mb-2" />
                <h3 className="font-semibold text-gray-800">Schedule Interview</h3>
                <p className="text-sm text-gray-600">Book your interview slot</p>
              </div>
            </div>
          </div>
          
          {/* Progress Tracker */}
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Your Progress</h3>
            <div className="flex items-center justify-center space-x-8">
              <div className="flex flex-col items-center">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mb-2">
                  <CheckCircle className="w-6 h-6 text-white" />
                </div>
                <span className="text-sm text-gray-600">Registered</span>
              </div>
              <div className="w-16 h-1 bg-gray-200 rounded"></div>
              <div className="flex flex-col items-center">
                <div className={`w-10 h-10 ${userData?.registrationStatus >= REGISTRATION_STATUS.PROFILE_COMPLETED ? 'bg-green-500' : 'bg-gray-300'} rounded-full flex items-center justify-center mb-2`}>
                  <User className="w-6 h-6 text-white" />
                </div>
                <span className="text-sm text-gray-600">Profile</span>
              </div>
              <div className="w-16 h-1 bg-gray-200 rounded"></div>
              <div className="flex flex-col items-center">
                <div className={`w-10 h-10 ${userData?.testStatus === 'completed' ? 'bg-green-500' : 'bg-gray-300'} rounded-full flex items-center justify-center mb-2`}>
                  <BookOpen className="w-6 h-6 text-white" />
                </div>
                <span className="text-sm text-gray-600">Test</span>
              </div>
              <div className="w-16 h-1 bg-gray-200 rounded"></div>
              <div className="flex flex-col items-center">
                <div className={`w-10 h-10 ${userData?.interviewRequested || userData?.interviewScheduled ? 'bg-green-500' : 'bg-gray-300'} rounded-full flex items-center justify-center mb-2`}>
                  <Calendar className="w-6 h-6 text-white" />
                </div>
                <span className="text-sm text-gray-600">Interview</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Profile Component
const ProfileComponent = ({ userData, onProfileUpdate }) => {
  const dispatch = useDispatch();
  const { whatsappVerified, isLoading } = useSelector(state => state.register);

  // Helper to safely handle mobile/whatsapp number and block 9999999999
  const safeNumberTrim = (num) => {
    if (!num) return '';
    let val = '';
    if (typeof num === 'string') val = num.trim();
    else if (typeof num === 'object' && num !== null) val = (num.number || num.whatsappNumber || '').trim();
    else val = String(num).trim();
    return val === '9999999999' ? '' : val;
  };

  // Helper function to safely join arrays for display
  const safeArrayJoin = (arr) => {
    if (!arr) return '';
    if (Array.isArray(arr)) return arr.join(', ');
    if (typeof arr === 'string') return arr;
    return '';
  };

  // Check if profile is completed using the numeric status
  const profileCompleted = isProfileCompleted(userData?.registrationStatus);

  // Initialize form data with safe handling and schema match
  const [formData, setFormData] = useState(() => {
    const existingData = userData || {};
    return {
      fullName: existingData?.fullName || '',
      email: existingData?.email || '',
      mobileNumber: safeNumberTrim(existingData?.mobileNumber) || safeNumberTrim(existingData?.phone) || '',
      whatsappNumber: safeNumberTrim(existingData?.whatsappNumber) || '',
      isWhatsappVerified: existingData?.whatsappNumber?.verified || existingData?.isWhatsappVerified || whatsappVerified || false,
      highestQualification: existingData?.highestQualification || existingData?.highest_degree || '',
      expertiseDomain: existingData?.expertiseDomain || existingData?.department || existingData?.role || '',
      qualificationsAndCertifications: Array.isArray(existingData?.qualificationsAndCertifications) ? existingData.qualificationsAndCertifications : (Array.isArray(existingData?.qualifications) ? existingData.qualifications : []),
      areasOfExpertise: Array.isArray(existingData?.areasOfExpertise) ? existingData.areasOfExpertise : (Array.isArray(existingData?.subjects) ? existingData.subjects : []),
      softwareSkills: Array.isArray(existingData?.softwareSkills) ? existingData.softwareSkills : (Array.isArray(existingData?.software_skills) ? existingData.software_skills : []),
      languagesKnown: Array.isArray(existingData?.languagesKnown) ? existingData.languagesKnown : (Array.isArray(existingData?.languages) ? existingData.languages : []),
      timeZone: existingData?.timeZone || 'Asia/Kolkata'
    };
  });

  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [newQualification, setNewQualification] = useState({
    institution: '',
    title: '',
    specialization: '',
    yearOfCompletion: ''
  });

  // Separate state for input values to avoid React controlled component issues
  const [inputValues, setInputValues] = useState(() => {
    const existingData = userData || {};
    return {
      areasOfExpertise: safeArrayJoin(existingData?.areasOfExpertise || existingData?.subjects || []),
      softwareSkills: safeArrayJoin(existingData?.softwareSkills || existingData?.software_skills || []),
      languagesKnown: safeArrayJoin(existingData?.languagesKnown || existingData?.languages || [])
    };
  });

  // Dropdown options
  const highestQualificationOptions = [
    'High School (10th)',
    'Senior Secondary (12th)',
    'Diploma',
    'Bachelor\'s Degree',
    'Master\'s Degree',
    'PhD/Doctorate',
    'Professional Certification',
    'Other'
  ];

  // Update form data when userData changes
  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setFormData(prevFormData => ({
        fullName: userData?.fullName || prevFormData.fullName,
        email: userData?.email || prevFormData.email,
        
        // Safely handle mobile number
        mobileNumber: (() => {
          const mobile = userData?.mobileNumber;
          if (typeof mobile === 'string') return mobile;
          if (typeof mobile === 'object' && mobile?.number) return mobile.number;
          return userData?.phone || prevFormData.mobileNumber || '';
        })(),
        
        // Safely handle whatsapp number
        whatsappNumber: (() => {
          const whatsapp = userData?.whatsappNumber;
          if (typeof whatsapp === 'string') return whatsapp;
          if (typeof whatsapp === 'object' && whatsapp?.number) return whatsapp.number;
          return prevFormData.whatsappNumber || '';
        })(),
        
        isWhatsappVerified: userData?.whatsappNumber?.verified || whatsappVerified || prevFormData.isWhatsappVerified,
        highestQualification: userData?.highestQualification || prevFormData.highestQualification,
        expertiseDomain: userData?.expertiseDomain || prevFormData.expertiseDomain,
        qualificationsAndCertifications: userData?.qualificationsAndCertifications?.length > 0 ? 
                                        userData.qualificationsAndCertifications : prevFormData.qualificationsAndCertifications,
        areasOfExpertise: userData?.areasOfExpertise?.length > 0 ? userData.areasOfExpertise : prevFormData.areasOfExpertise,
        softwareSkills: userData?.softwareSkills?.length > 0 ? userData.softwareSkills : prevFormData.softwareSkills,
        languagesKnown: userData?.languagesKnown?.length > 0 ? userData.languagesKnown : prevFormData.languagesKnown,
        timeZone: userData?.timeZone || prevFormData.timeZone
      }));
      
      // Update input values for display
      setInputValues({
        areasOfExpertise: safeArrayJoin(userData?.areasOfExpertise || userData?.subjects || []),
        softwareSkills: safeArrayJoin(userData?.softwareSkills || userData?.software_skills || []),
        languagesKnown: safeArrayJoin(userData?.languagesKnown || userData?.languages || [])
      });
    }
  }, [userData, whatsappVerified]);

  // Sync WhatsApp verification status from Redux
  useEffect(() => {
    const isVerified = userData?.whatsappNumber?.verified || whatsappVerified || false;
    setFormData(prev => ({
      ...prev,
      isWhatsappVerified: isVerified
    }));
  }, [userData?.whatsappNumber?.verified, whatsappVerified]);

  const handleInputChange = (e) => {
    if (profileCompleted) {
      toast.info('Profile is completed and cannot be modified');
      return;
    }
    
    const { name, value, type, checked } = e.target;
    
    let processedValue = type === 'checkbox' ? checked : value;
    
    // Ensure whatsappNumber and mobileNumber are always strings
    if (name === 'whatsappNumber' || name === 'mobileNumber') {
      processedValue = typeof value === 'string' ? value : String(value || '');
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: processedValue
    }));
  };

  const handleArrayInput = (field, value) => {
    if (profileCompleted) {
      toast.info('Profile is completed and cannot be modified');
      return;
    }
    
    // Update the input value immediately for better UX
    setInputValues(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Process the value into array
    const items = value ? value.split(',').map(item => item.trim()).filter(item => item !== '') : [];
    
    setFormData(prev => ({ 
      ...prev, 
      [field]: items 
    }));
  };

  // WhatsApp verification handlers
  const handleWhatsAppVerify = () => {
    if (profileCompleted) {
      toast.info('Profile is completed and cannot be modified');
      return;
    }
    
    if (formData.isWhatsappVerified) {
      toast.info('✅ WhatsApp number is already verified!');
      return;
    }

    const whatsappNum = safeNumberTrim(formData.whatsappNumber);
    
    console.log('WhatsApp verification attempt:');
    console.log('- Raw formData.whatsappNumber:', formData.whatsappNumber);
    console.log('- Processed WhatsApp number:', whatsappNum);
    console.log('- Full formData:', formData);
    
    if (!whatsappNum || whatsappNum === '') {
      toast.error('Please enter WhatsApp number first');
      return;
    }
    if (!formData.fullName || formData.fullName.trim() === '') {
      toast.error('Please enter your full name first');
      return;
    }
    if (!/^\d{10}$/.test(whatsappNum)) {
      toast.error('Please enter a valid 10-digit WhatsApp number');
      return;
    }

    setShowWhatsAppModal(true);
  };

  const handleWhatsAppVerified = async (verified) => {
    console.log('WhatsApp verification status changed to:', verified);
    console.log('Current formData.whatsappNumber before update:', formData.whatsappNumber);
    
    setFormData(prev => ({ ...prev, isWhatsappVerified: verified }));
    
    if (verified) {
      toast.success('✅ WhatsApp number verified successfully!');
      
      try {
        // Get the actual WhatsApp number from form input
        const actualWhatsAppNumber = safeNumberTrim(formData.whatsappNumber);
        
        console.log('Sending actual WhatsApp number to backend:', actualWhatsAppNumber);
        
        const verificationUpdate = {
          whatsappNumber: {
            countryCode: '+91',
            number: actualWhatsAppNumber, // Use actual number from form
            verified: true
          },
          isWhatsappVerified: true
        };
        
        const result = await dispatch(updateUserProfile(verificationUpdate)).unwrap();
        
        // Update Redux state
        dispatch(updateUserData({
          whatsappNumber: {
            countryCode: '+91',
            number: actualWhatsAppNumber,
            verified: true
          }
        }));
        
        toast.success('✅ Verification status synchronized with database!');
      } catch (error) {
        console.error('Failed to save WhatsApp verification to database:', error);
        toast.error('⚠️ Verification successful but failed to sync with database.');
      }
    }
  };

  // Qualification handlers
  const addQualification = () => {
    if (profileCompleted) {
      toast.info('Profile is completed and cannot be modified');
      return;
    }
    
    if (newQualification.institution && newQualification.title) {
      setFormData(prev => ({
        ...prev,
        qualificationsAndCertifications: [...prev.qualificationsAndCertifications, { ...newQualification }]
      }));
      setNewQualification({
        institution: '',
        title: '',
        specialization: '',
        yearOfCompletion: ''
      });
    } else {
      toast.error('Please fill institution and qualification title');
    }
  };

  const removeQualification = (index) => {
    if (profileCompleted) {
      toast.info('Profile is completed and cannot be modified');
      return;
    }
    
    setFormData(prev => ({
      ...prev,
      qualificationsAndCertifications: prev.qualificationsAndCertifications.filter((_, i) => i !== index)
    }));
  };

  // Enhanced form completion check
  const isFormComplete = () => {
    const whatsappNum = safeNumberTrim(formData.whatsappNumber);
    const mobileNum = safeNumberTrim(formData.mobileNumber);
    // Block 9999999999 and require 10 digits
    const basicInfoComplete = (
      formData.fullName.trim() !== '' &&
      mobileNum !== '' &&
      /^\d{10}$/.test(mobileNum) &&
      mobileNum !== '9999999999' &&
      whatsappNum !== '' &&
      /^\d{10}$/.test(whatsappNum) &&
      whatsappNum !== '9999999999'
    );

    const whatsappVerifiedCheck = formData.isWhatsappVerified;

    const educationComplete = (
      formData.highestQualification !== '' &&
      formData.expertiseDomain !== '' &&
      formData.timeZone !== ''
    );

    const qualificationsComplete = (
      formData.qualificationsAndCertifications.length > 0 &&
      formData.qualificationsAndCertifications.every(qual => 
        qual.institution.trim() !== '' && 
        qual.title.trim() !== '' && 
        qual.specialization.trim() !== '' && 
        qual.yearOfCompletion.trim() !== ''
      )
    );

    const skillsComplete = (
      formData.areasOfExpertise.length > 0 &&
      formData.softwareSkills.length > 0 &&
      formData.languagesKnown.length > 0
    );

    return basicInfoComplete && whatsappVerifiedCheck && educationComplete && qualificationsComplete && skillsComplete;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (profileCompleted) {
      toast.info('Profile is completed and cannot be modified');
      return;
    }

    // Validate WhatsApp verification before allowing profile update
    if (!formData.isWhatsappVerified) {
      toast.error('Please verify your WhatsApp number before updating profile');
      return;
    }

    try {
      // Prepare data according to backend API structure
      const updateData = {
        fullName: formData.fullName.trim(),
        email: formData.email,
        mobileNumber: {
          countryCode: '+91',  
          number: typeof formData.mobileNumber === 'string' ? formData.mobileNumber.trim() : String(formData.mobileNumber || '').trim()
        },
        whatsappNumber: {
          countryCode: '+91',
          number: safeNumberTrim(formData.whatsappNumber),
          verified: formData.isWhatsappVerified
        },
        highestQualification: formData.highestQualification,
        expertiseDomain: formData.expertiseDomain,
        qualificationsAndCertifications: formData.qualificationsAndCertifications,
        areasOfExpertise: formData.areasOfExpertise,
        softwareSkills: formData.softwareSkills,
        languagesKnown: formData.languagesKnown,
        timeZone: formData.timeZone,
        isWhatsappVerified: formData.isWhatsappVerified,
        token: localStorage.getItem('registerToken') || ''
      };

      console.log('Submitting profile update with data:', updateData);

      const resultAction = await dispatch(updateUserProfile(updateData));
      
      if (updateUserProfile.fulfilled.match(resultAction)) {
        const result = resultAction.payload.result;
        console.log('Profile update successful - Backend response:', result);
        
        setUpdateSuccess(true);
        toast.success('✅ Profile updated successfully!');
        
        // Call parent callback if provided
        if (onProfileUpdate) {
          onProfileUpdate(result);
        }
        
        // Auto-hide success message after 5 seconds
        setTimeout(() => {
          setUpdateSuccess(false);
        }, 5000);
      } else {
        throw new Error(resultAction.payload?.message || 'Update failed');
      }
      
    } catch (error) {
      console.error('Profile update failed:', error);
      const errorMessage = error?.message || error?.error || 'Failed to update profile. Please try again.';
      toast.error(`❌ Update Failed: ${errorMessage}`);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8">
        {/* Header Section */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
            <User className="w-8 h-8 text-gray-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            My Profile
          </h2>
          <p className="text-gray-600">
            {profileCompleted ? 'Your profile is completed and locked for editing' : 'Complete your professional profile to get started'}
          </p>
          <div className="w-24 h-1 bg-gray-300 rounded-full mx-auto mt-4"></div>
          
          {/* Profile Status Banner */}
          {profileCompleted && (
            <div className="mt-6 bg-green-50 border-2 border-green-200 rounded-xl p-6 max-w-md mx-auto">
              <div className="flex items-center justify-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <CheckCircle className="w-8 h-8 text-green-600" />
                </div>
                <div className="text-left">
                  <h3 className="text-lg font-bold text-green-800">Profile Completed!</h3>
                  <p className="text-green-700 text-sm">Your registration has been finalized and is now read-only.</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="space-y-10">
          {/* Success Message */}
          {updateSuccess && (
            <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-50 border-2 border-green-200 rounded-xl p-8 mb-8 shadow-2xl animate-bounce">
              <div className="flex items-center justify-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-6 animate-pulse">
                  <CheckCircle className="w-10 h-10 text-green-600" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-green-800 mb-2">🎉 Profile Updated Successfully!</h3>
                  <p className="text-green-700 text-lg">Your information has been saved and is now up to date.</p>
                  <div className="mt-2 text-sm text-green-600">
                    ✅ All changes have been synchronized with the database
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Basic Information */}
          <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center mr-3">
                <User className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Basic Information</h3>
              {profileCompleted && (
                <div className="ml-auto">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    Completed
                  </span>
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Full Name */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Full Name
                </label>
                <input 
                  type="text" 
                  name="fullName" 
                  value={formData.fullName} 
                  onChange={handleInputChange} 
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  placeholder="Enter your full name"
                  disabled={profileCompleted}
                  required 
                />
              </div>
              
              {/* Email ID (disabled) */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3">Email ID</label>
                <input 
                  type="email" 
                  name="email" 
                  value={formData.email} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 cursor-not-allowed" 
                  disabled 
                />
              </div>

              {/* Mobile Number with country code */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Mobile Number
                </label>
                <div className="flex">
                  <div className="w-20 px-3 py-3 border border-gray-300 rounded-l-lg bg-gray-100 flex items-center justify-center text-sm font-medium text-gray-700 border-r-0">
                    +91
                  </div>
                  <input 
                    type="tel" 
                    name="mobileNumber" 
                    value={formData.mobileNumber} 
                    onChange={handleInputChange} 
                    className={`flex-1 px-4 py-3 border border-gray-300 rounded-r-lg focus:outline-none transition-all duration-200 ${
                      profileCompleted 
                        ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                        : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                    }`}
                    placeholder="9876543210"
                    pattern="[0-9]{10}"
                    disabled={profileCompleted}
                    required
                  />
                </div>
              </div>

              {/* WhatsApp Number with verification */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  WhatsApp Number
                </label>
                <div className="flex items-center space-x-3">
                  <div className="flex flex-1">
                    <div className="w-20 px-3 py-3 border border-gray-300 rounded-l-lg bg-gray-100 flex items-center justify-center text-sm font-medium text-gray-700 border-r-0">
                      +91
                    </div>
                    <input 
                      type="tel" 
                      name="whatsappNumber" 
                      value={formData.whatsappNumber} 
                      onChange={handleInputChange} 
                      className={`flex-1 px-4 py-3 border border-gray-300 rounded-r-lg focus:outline-none transition-all duration-200 ${
                        profileCompleted 
                          ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                          : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                      }`}
                      placeholder="9876543210"
                      pattern="[0-9]{10}"
                      disabled={profileCompleted}
                      required
                    />
                  </div>
                  {formData.isWhatsappVerified ? (
                    <div className="flex items-center space-x-2 px-4 py-3 bg-green-50 border border-green-200 rounded-lg">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      <span className="text-sm font-medium text-green-700">Verified</span>
                    </div>
                  ) : (
                    <button 
                      type="button" 
                      onClick={handleWhatsAppVerify}
                      className={`px-6 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
                        profileCompleted
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-md'
                      }`}
                      disabled={profileCompleted}
                    >
                      Verify
                    </button>
                  )}
                </div>
                {!formData.isWhatsappVerified && !profileCompleted && (
                  <p className="text-xs text-orange-600 mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    WhatsApp verification is required to complete your profile
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Education & Professional Information */}
          <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center mr-3">
                <BookOpen className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Education & Professional Information</h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Highest Qualification */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Highest Qualification
                </label>
                <select 
                  name="highestQualification" 
                  value={formData.highestQualification} 
                  onChange={handleInputChange} 
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  disabled={profileCompleted}
                  required
                >
                  <option value="">Select your highest qualification</option>
                  {highestQualificationOptions.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>

              {/* Expertise Domain */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Expertise Domain
                </label>
                <select 
                  name="expertiseDomain" 
                  value={formData.expertiseDomain} 
                  onChange={handleInputChange} 
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  disabled={profileCompleted}
                  required
                >
                  <option value="">Select your expertise domain</option>
                  <option value="Academic Tutor">Academic Tutor</option>
                  <option value="Music Tutor">Music Tutor</option>
                </select>
              </div>

              {/* Time Zone */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Time Zone
                </label>
                <select 
                  name="timeZone" 
                  value={formData.timeZone} 
                  onChange={handleInputChange} 
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  disabled={profileCompleted}
                  required
                >
                  <option value="Asia/Kolkata">Asia/Kolkata (IST)</option>
                  <option value="America/New_York">America/New_York (EST)</option>
                  <option value="Europe/London">Europe/London (GMT)</option>
                  <option value="Asia/Dubai">Asia/Dubai (GST)</option>
                </select>
              </div>
            </div>
          </div>

          {/* Qualifications and Certifications */}
          <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center mr-3">
                <CheckCircle className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Qualifications & Certifications</h3>
            </div>

            {/* Existing Qualifications */}
            {formData.qualificationsAndCertifications.length > 0 && (
              <div className="space-y-4 mb-6">
                {formData.qualificationsAndCertifications.map((qual, index) => (
                  <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-800 mb-1">{qual.title}</h4>
                        <p className="text-gray-600 mb-1">{qual.institution}</p>
                        <p className="text-sm text-gray-500">{qual.specialization} • {qual.yearOfCompletion}</p>
                      </div>
                      {!profileCompleted && (
                        <button 
                          type="button" 
                          onClick={() => removeQualification(index)}
                          className="ml-4 p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Add New Qualification */}
            {!profileCompleted && (
              <div className="bg-white p-6 rounded-lg border-2 border-dashed border-gray-300 hover:border-gray-400 transition-all duration-200">
                <h4 className="font-medium text-gray-700 mb-4 flex items-center">
                  <Plus className="w-5 h-5 mr-2 text-gray-500" />
                  Add Qualification/Certification
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input 
                    type="text" 
                    placeholder="Institution/Organization*" 
                    value={newQualification.institution}
                    onChange={(e) => setNewQualification(prev => ({...prev, institution: e.target.value}))}
                    className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                  />
                  <input 
                    type="text" 
                    placeholder="Qualification/Certification Title*" 
                    value={newQualification.title}
                    onChange={(e) => setNewQualification(prev => ({...prev, title: e.target.value}))}
                    className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                  />
                  <input 
                    type="text" 
                    placeholder="Specialization/Field of Study*" 
                    value={newQualification.specialization}
                    onChange={(e) => setNewQualification(prev => ({...prev, specialization: e.target.value}))}
                    className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                  />
                  <input 
                    type="text" 
                    placeholder="Year of Completion*" 
                    value={newQualification.yearOfCompletion}
                    onChange={(e) => setNewQualification(prev => ({...prev, yearOfCompletion: e.target.value}))}
                    className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
                  />
                </div>
                <button 
                  type="button" 
                  onClick={addQualification}
                  className="mt-4 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium"
                >
                  Add Qualification
                </button>
              </div>
            )}
          </div>

          {/* Skills & Expertise */}
          <div className={`rounded-lg p-8 border border-gray-200 ${profileCompleted ? 'bg-gray-50 opacity-75' : 'bg-gray-50'}`}>
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                <Brain className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">Skills & Expertise</h3>
            </div>
            <div className="space-y-6">
              {/* Areas of Expertise */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Areas of Expertise
                </label>
                <textarea 
                  placeholder="Enter your areas of expertise (separated by commas)" 
                  value={inputValues.areasOfExpertise}
                  onChange={(e) => handleArrayInput('areasOfExpertise', e.target.value)}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 resize-none ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  rows="3"
                  disabled={profileCompleted}
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Example: Mathematics, Physics, Chemistry</p>
              </div>

              {/* Software Skills */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Software Skills
                </label>
                <textarea 
                  placeholder="Enter your software skills (separated by commas)" 
                  value={inputValues.softwareSkills}
                  onChange={(e) => handleArrayInput('softwareSkills', e.target.value)}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 resize-none ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  rows="3"
                  disabled={profileCompleted}
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Example: Microsoft Office, Photoshop, Python</p>
              </div>

              {/* Languages Known */}
              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-3 flex items-center">
                  <span className="text-red-500 mr-1">*</span>
                  Languages Known
                </label>
                <textarea 
                  placeholder="Enter languages you know (separated by commas)" 
                  value={inputValues.languagesKnown}
                  onChange={(e) => handleArrayInput('languagesKnown', e.target.value)}
                  className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none transition-all duration-200 resize-none ${
                    profileCompleted 
                      ? 'bg-gray-100 text-gray-600 cursor-not-allowed' 
                      : 'bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                  }`}
                  rows="3"
                  disabled={profileCompleted}
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Example: English, Hindi, Spanish</p>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          {!profileCompleted && (
            <div className="text-center">
              <button 
                type="submit" 
                disabled={isLoading || !isFormComplete()}
                className={`px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-200 ${
                  isLoading || !isFormComplete()
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700 hover:shadow-lg'
                }`}
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                    Updating Profile...
                  </div>
                ) : (
                  'Update Profile'
                )}
              </button>
              <p className="text-sm text-gray-500 mt-4">
                {isFormComplete() 
                  ? '✅ All required fields are completed' 
                  : '⚠️ Please complete all required fields and verify your WhatsApp number'
                }
              </p>
            </div>
          )}
        </form>

        {/* WhatsApp Verification Modal */}
        {showWhatsAppModal && (
          <VerifyWhatsAppNumModal
            open={showWhatsAppModal}
            handleClose={() => setShowWhatsAppModal(false)}
            setIsWhatsappVerified={handleWhatsAppVerified}
            waNum={formData.whatsappNumber}
            name={formData.fullName}
            isVerified={formData.isWhatsappVerified}
          />
        )}
      </div>
    </div>
  );
};

// Academic Test Component
const AcademicTestComponent = ({ userData }) => {
  const [showAcademicTest, setShowAcademicTest] = useState(false);
  const [isTestLoading, setIsTestLoading] = useState(false);
  const [testError, setTestError] = useState('');
  const dispatch = useDispatch();

  const setupAcademicTest = async () => {
    setIsTestLoading(true);
    setTestError('');
    
    try {
      // No localStorage setup needed - just show the test
      setShowAcademicTest(true);
    } catch (error) {
      console.error('Error setting up academic test:', error);
      setTestError('Failed to setup test environment');
    } finally {
      setIsTestLoading(false);
    }
  };

  const handleTestComplete = (results) => {
    setShowAcademicTest(false);
    // Update Redux state with test results
    dispatch(updateUserData({ 
      testResults: results,
      testCompleted: true 
    }));
    toast.success('Academic test completed successfully!');
  };

  const handleTestError = (error) => {
    setTestError(error);
    setShowAcademicTest(false);
  };

  if (showAcademicTest) {
    return (
      <AcademicTest 
        userData={userData}
        onTestComplete={handleTestComplete}
        onTestError={handleTestError}
      />
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <BookOpen className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Academic Assessment</h2>
          <p className="text-gray-600">Demonstrate your expertise in your chosen field</p>
        </div>
        
        {testError && (
          <div className="mb-6 bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
            <div className="flex items-center">
              <AlertCircle className="w-5 h-5 text-red-400 mr-3" />
              <span className="text-red-800 font-medium">Error setting up test environment. Please try again.</span>
            </div>
          </div>
        )}

        {isTestLoading && (
          <div className="mb-6 bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-3"></div>
              <span className="text-blue-800 font-medium">Preparing test environment...</span>
            </div>
          </div>
        )}

        <div className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Test Instructions</h3>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                Complete the academic test to demonstrate your expertise in your field.
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                The test consists of multiple-choice questions related to your expertise domain.
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                You will have a limited time to complete the assessment.
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                Ensure you have a stable internet connection before starting.
              </li>
            </ul>
          </div>

          {userData?.testCompleted ? (
            <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded-lg">
              <div className="flex items-center">
                <CheckCircle className="w-5 h-5 text-green-400 mr-3" />
                <span className="text-green-800 font-medium">
                  You have successfully completed the academic test. Results are being reviewed.
                </span>
              </div>
            </div>
          ) : userData?.expertiseDomain === 'Music Tutor' ? (
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
              <div className="flex items-center">
                <Info className="w-5 h-5 text-blue-400 mr-3" />
                <span className="text-blue-800 font-medium">
                  Academic test is only required for Academic Tutors. Music Tutors need to schedule an interview instead.
                </span>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <button
                onClick={setupAcademicTest}
                disabled={isTestLoading}
                className={`px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-200 ${
                  isTestLoading
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-green-500 to-blue-500 text-white hover:from-green-600 hover:to-blue-600 hover:shadow-lg'
                }`}
              >
                {isTestLoading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                    Setting up...
                  </div>
                ) : (
                  'Start Academic Test'
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Interview Scheduler Component
const InterviewScheduler = ({ userData }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [notes, setNotes] = useState('');
  const dispatch = useDispatch();
  const { isLoading } = useSelector(state => state.register);

  const handleScheduleInterview = async (e) => {
    e.preventDefault();
    
    if (!selectedDate || !selectedTime) {
      toast.error('Please select both date and time for the interview');
      return;
    }

    try {
      const interviewData = {
        scheduledDate: selectedDate,
        scheduledTime: selectedTime,
        notes: notes || 'No additional notes provided',
        interviewType: userData?.expertiseDomain === 'Music Tutor' ? 'music_performance' : 'academic_discussion'
      };

      await dispatch(scheduleInterview(interviewData)).unwrap();
      toast.success('Interview scheduled successfully!');
      setSelectedDate('');
      setSelectedTime('');
      setNotes('');
    } catch (error) {
      toast.error(error.message || 'Failed to schedule interview');
    }
  };

  // Get available dates (next 30 days, excluding weekends)
  const getAvailableDates = () => {
    const dates = [];
    const today = new Date();
    
    for (let i = 1; i <= 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      
      // Skip weekends
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        dates.push(date.toISOString().split('T')[0]);
      }
    }
    
    return dates;
  };

  // Available time slots
  const timeSlots = [
    '09:00', '10:00', '11:00', '14:00', '15:00', '16:00', '17:00'
  ];

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <Calendar className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Schedule Interview</h2>
          <p className="text-gray-600">Book your interview slot with our team</p>
        </div>
        
        {userData?.interviewScheduled ? (
          <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg text-center">
            <div className="flex items-center justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-green-400 mr-3" />
              <span className="text-xl font-semibold text-green-800">Interview Scheduled!</span>
            </div>
            <p className="text-green-700">
              Your interview has been scheduled. Check your email for details and meeting link.
            </p>
          </div>
        ) : (
          <form onSubmit={handleScheduleInterview} className="space-y-6">
            <div className="bg-gray-50 rounded-lg p-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Interview Information</h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  Interviews are conducted via video call
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  Duration: 30-45 minutes
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  You'll receive a confirmation email with the meeting link
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  Please ensure you have a stable internet connection
                </li>
                {userData?.expertiseDomain === 'Music Tutor' && (
                  <li className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    Be prepared to demonstrate your musical skills
                  </li>
                )}
              </ul>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Preferred Date *
                </label>
                <select
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                  required
                >
                  <option value="">Select a date</option>
                  {getAvailableDates().map(date => (
                    <option key={date} value={date}>
                      {new Date(date).toLocaleDateString('en-US', { 
                        weekday: 'long', 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric' 
                      })}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Preferred Time *
                </label>
                <select
                  value={selectedTime}
                  onChange={(e) => setSelectedTime(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                  required
                >
                  <option value="">Select a time</option>
                  {timeSlots.map(time => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Additional Notes (Optional)
              </label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 resize-none"
                placeholder="Any specific requirements or preferences for the interview..."
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                disabled={isLoading}
                className={`px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-200 ${
                  isLoading
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600 hover:shadow-lg'
                }`}
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                    Scheduling...
                  </div>
                ) : (
                  'Schedule Interview'
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

// Main Dashboard Component
const RegisterDashboard = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData, isLoading, error } = useSelector(state => state.register);

  useEffect(() => {
    const verifyUserSession = async () => {
      try {
        await dispatch(verifyUser()).unwrap();
      } catch (error) {
        console.error('User verification failed:', error);
        navigate('/register');
      }
    };

    verifyUserSession();
  }, [dispatch, navigate]);

  const handleLogout = async () => {
    const result = await MySwal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of your account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout'
    });

    if (result.isConfirmed) {
      dispatch(logout());
      navigate('/register');
      toast.success('Logged out successfully');
    }
  };

  const handleProfileUpdate = (updatedData) => {
    // Profile update is handled by Redux automatically
    console.log('Profile updated:', updatedData);
  };

  const sidebarItems = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'profile', label: 'Profile', icon: User },
    { id: 'academic-test', label: 'Academic Test', icon: BookOpen },
    { id: 'interview', label: 'Interview', icon: Calendar },
    { id: 'logout', label: 'Logout', icon: LogOut },
  ];

  if (isLoading && !userData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  if (error && !userData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <AlertCircle className="w-16 h-16 text-red-600 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Session Expired</h2>
          <p className="text-gray-600 mb-4">Please log in again to continue</p>
          <button
            onClick={() => navigate('/register')}
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all duration-200"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0 lg:static lg:inset-0`}>
        <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
          <div className="flex items-center">
            <div className="w-10 h-14 bg-indigo-500 rounded-lg flex items-center justify-center">
              <img src={logo} alt="Logo" className="h-7 w-7" />
            </div>
            <span className="ml-2 text-xl font-semibold text-gray-800">Register</span>
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <nav className="mt-8">
          {sidebarItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => {
                  if (item.id === 'logout') {
                    handleLogout();
                  } else {
                    setActiveSection(item.id);
                    setSidebarOpen(false);
                  }
                }}
                className={`w-full flex items-center px-4 py-3 text-left hover:bg-gray-50 transition-colors ${
                  activeSection === item.id ? 'bg-indigo-50 text-indigo-600 border-r-2 border-indigo-600' : 'text-gray-700'
                }`}
              >
                <Icon className="w-5 h-5 mr-3" />
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 lg:ml-0">
        {/* Header */}
        <div className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between h-16 px-4">
            <div className="flex items-center">
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500"
              >
                <Menu className="w-5 h-5" />
              </button>
              <div className="lg:hidden flex items-center ml-2">
                <div className="w-8 h-8 bg-indigo-500 rounded-lg flex items-center justify-center">
                  <img src={logo} alt="Logo" className="h-5 w-5" />
                </div>
                <span className="ml-2 text-xl font-semibold text-gray-800">Register</span>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">{userData?.email}</span>
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                <User className="w-4 h-4 text-gray-400" />
              </div>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="p-6">
          {activeSection === 'home' && <HomeScreen userData={userData} />}
          {activeSection === 'profile' && <ProfileComponent userData={userData} onProfileUpdate={handleProfileUpdate} />}
          {activeSection === 'academic-test' && <AcademicTestComponent userData={userData} />}
          {activeSection === 'interview' && <InterviewScheduler userData={userData} />}
        </div>
      </div>

      {/* Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default RegisterDashboard;
